import { startPageUrl } from '../lib/sites';

// Header link from any staff site back to the start page (staff.silverservice.com).
// Each header passes its own button style so the link matches its neighbours.
export default function AllSitesLink({ style }) {
  return (
    <a href={startPageUrl()} style={{ textDecoration: 'none', display: 'inline-block', ...style }} title="Every Silver Service site, and what each one is for">
      All sites
    </a>
  );
}
